'use strict';

export default typeof Blob !== 'undefined' ? Blob : null;



// WEBPACK FOOTER //
// ../lib/platform/browser/classes/Blob.js